import SEO from "@/components/SEO";
import { PageHero, LegalDoc } from "@/components/Bits";
import { REFUND } from "@/content/policies";

export default function Refund() {
  return (
    <div data-testid="refund-page">
      <SEO
        title="Refund, Cancellation & Delivery Policy"
        description="Middle Man refund, cancellation and delivery rules — service work requests, product orders, direct payments, Razorpay subscription refunds and dispute handling."
        path="/refund"
      />
      <PageHero
        kicker="Legal"
        title="Refund, Cancellation & Delivery Policy"
        subtitle="Effective from: 11 September 2026 · How cancellations, refunds and deliveries work on the Middle Man platform."
      />
      <LegalDoc doc={REFUND} />
    </div>
  );
}
